import React, { useState } from 'react'
import { TextField, Button, Box } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CancelIcon from '@mui/icons-material/Cancel'

export default ({ helpText, handleSearch }) => {
    const [search, setSearch] = useState('')

    return (
        <div style={{ display: 'flex', gap: '1rem', maxWidth: '400px', marginTop: '2rem', marginBottom: '1rem' }}>
            <div style={{ position: 'relative', width: '100%' }}>
                <TextField
                    size="small"
                    variant="outlined"
                    placeholder={helpText || 'Search'}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDownCapture={(e) => {
                        if (e.key === 'Enter') {
                            handleSearch(search)
                        }
                    }
                    }
                    fullWidth
                    InputProps={{
                        startAdornment: <SearchIcon fontSize='small' style={{ marginRight: '8px' }} />,
                    }}
                />
                {search && (
                    <Box
                        component="span"
                        style={{
                            position: 'absolute',
                            right: '0.5rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            setSearch('');
                            handleSearch('');
                        }}
                    >
                        <CancelIcon fontSize='small' />
                    </Box>
                )}
            </div>
            <Button variant="contained" color="primary" onClick={() => handleSearch(search)}>Search</Button>
        </div>
    )
}